
import { ContentBlock } from "@/bootstrap/components/content/block";
export default ContentBlock.extend({
  name: "content-block-img-01",
  computed: {
    breakpoint() {
      return (this as any).block?.config?.breakpoint;
    },
    height() {
      return (this as any).block?.config?.height;
    },
  },
  methods: {
    async selectImage(selectFile, block, name) {
      const file = await selectFile();
      block.model[name] = `/api/v1/objectimage/p${file.id}.jpg`;
      await this.updateModel();
      (this as any).$message("Изображение успещно обновлено");
    },
  },
});
